// Max file sixe 50mb
export const MAX_FILE_SIZE = 50 * 1024 * 1024;

// min file size 500 bytes
export const MIN_FILE_SIZE = 500;

export const MAX_FILE_SIZE_MB = `${MAX_FILE_SIZE / 1024 / 1024} MB`;
